import React, { useId } from 'react';
import { useDialog } from '../hooks/useDialog';

// Accessible modal shell: labelled dialog, focus kept inside, Escape and
// backdrop click close it, focus returns to the opener afterwards.
export const Modal = ({ isOpen, onClose, title, children, footer, size = 'medium', role = 'dialog' }) => {
  const titleId = useId();
  const dialogRef = useDialog(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        ref={dialogRef}
        className={`modal-content modal-${size}`}
        role={role}
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div className="modal-header">
          <h2 id={titleId}>{title}</h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label={`Close ${title}`}>×</button>
        </div>

        <div className="modal-body">{children}</div>

        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
};
